// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listItemCss_l1bn7p4u{margin:0;padding:0;list-style:none;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-lang-picker/dist/es/LangList.css"],"names":[],"mappings":"AAAA,sBAAsB,QAAQ,CAAC,SAAS,CAAC,eAAe,CAAC","sourcesContent":[".listItemCss_l1bn7p4u{margin:0;padding:0;list-style:none;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
